import './header.scss';

import React, { useEffect, useRef } from 'react';
import { Nav, Navbar } from 'react-bootstrap';

import LoadingBar, { LoadingBarRef } from 'react-top-loading-bar';

import { useAppSelector } from 'app/config/store';
import { AccountMenu, AdminMenu } from '../menus';

import { Brand, Home } from './header-components';

/**
 * Label for the dev ribbon, by environment. Only `dev` ever had a translation; any other env now
 * falls back to its own name instead of rendering `translation-not-found[global.ribbon.<env>]`.
 */
const RIBBON_LABELS: Record<string, string> = { dev: 'Development' };

export interface IHeaderProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
}

const Header = (props: IHeaderProps) => {
  const loadingBarRef = useRef<LoadingBarRef>(null);
  const loadingCount = useAppSelector(state => state.loadingBar.count);

  useEffect(() => {
    if (loadingCount > 0) {
      loadingBarRef.current?.continuousStart();
    } else {
      loadingBarRef.current?.complete();
    }
  }, [loadingCount]);

  const renderDevRibbon = () =>
    !props.isInProduction && (
      <div className="ribbon dev">
        <a href="">{RIBBON_LABELS[props.ribbonEnv] ?? props.ribbonEnv}</a>
      </div>
    );

  return (
    <div id="app-header">
      {renderDevRibbon()}
      <LoadingBar ref={loadingBarRef} className="loading-bar" color="#bd8f6f" />
      <Navbar data-cy="navbar" data-bs-theme="light" expand="md" fixed="top" className="app-navbar" collapseOnSelect>
        <Navbar.Toggle aria-controls="header-tabs" aria-label="Menu" />
        <Brand />
        <Navbar.Collapse id="header-tabs">
          <Nav className="ms-auto">
            <Home />
            {props.isAuthenticated && props.isAdmin && <AdminMenu showOpenAPI={props.isOpenAPIEnabled} />}
            <AccountMenu isAuthenticated={props.isAuthenticated} />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
